import { defineAction } from '~/prix'
import { z } from 'zod'
import materialDeliveryImageUpdateAction from './materialDeliveryImageUpdate.action.json' with { type: 'json' }
import { materialDeliveryImageObject } from '../materialDeliveryImageObject'

const materialDeliveryImageUpdateDefinition = defineAction({
  ...materialDeliveryImageUpdateAction,
  input: materialDeliveryImageObject
    .pick({
      id: true,
      description: true,
      position: true,
      status: true,
    })
    .partial({ description: true, position: true, status: true }),
  output: z.object({}),
})

export default materialDeliveryImageUpdateDefinition
